import { HUB, TEAMS_HUB, WIN32_OUTLOOK_HUB, OWA_HUB, IOS_OUTLOOK, MONARCH_HUB, OFFICE_WEB, OFFICE_DESKTOP, OFFICE_IOS, OFFICE_OTHER_HUB, OFFICE_ANDROID, OUTLOOK_OTHER_HUB, ANDROID_OUTLOOK, WINDOWSACTIONCENTER, } from "./types/HostApp";
import { getQueryStringParameter, hasQueryStringParameter } from "owa-querystring";
import { isRunningInMetaOSHub } from "./isRunningInMetaOSHub";
import { setHostClientType } from "./getHostClientType";

const validHubNames = [
    "teams", //Teams v1
    "teamsmodern", //Teams v2.1
    "outlook", //Outlook Native (Monarch) or OWA
    "outlookwin32", //Outlook Win32
    "office",
    "windowsactioncenter", // Windows Shell Action Center
];

// https://github.com/OfficeDev/microsoft-teams-library-js/blob/main/packages/teams-js/src/public/constants.ts#L2
const validHostClientType = ["desktop", "web", "ios", "android", "ipados", "macos"];

export let currentHub: string | undefined;
export function setHostHub(hubName: string, hostClientType: string | undefined): void {
    // To smooth the transition to using context, we are respecting the hostApp param if the MetaOS app is still using it
    // if the param is removed, we will use the information from the context to deduce the hostHub
    // The removal of hostApp param is tracked by WI:169112
    const validValues = [
        HUB,
        TEAMS_HUB,
        WIN32_OUTLOOK_HUB,
        MONARCH_HUB,
        OWA_HUB,
        OFFICE_WEB,
        OFFICE_DESKTOP,
        WINDOWSACTIONCENTER,
    ];
    let parameterValue;
    if (hasQueryStringParameter("hostApp")) {
        parameterValue = getQueryStringParameter("hostApp").toLowerCase();
    }
    else if (hasQueryStringParameter("testHostApp")) {
        parameterValue = getQueryStringParameter("testHostApp").toLowerCase();
    }
    
    if (parameterValue && validValues.includes(parameterValue)) {
        currentHub = parameterValue;
    }
    
    const isHosted = isRunningInMetaOSHub();
    if ((!currentHub || currentHub == validValues[0] || currentHub == validValues[1]) && isHosted) {
        const hubNameLowerCase = hubName?.toLowerCase() || "";
        const hostClientTypeLowerCase = hostClientType?.toLowerCase() || "";
        
        if (hubName &&
            validHubNames.includes(hubNameLowerCase) &&
            hostClientType &&
            validHostClientType.includes(hostClientTypeLowerCase)) {
            setHostClientType(hostClientTypeLowerCase);
            
            if (hubNameLowerCase === "teams" || hubNameLowerCase === "teamsmodern") {
                // we distinguish web vs desktop via a column called ClientPlatform, to match Sydney
                currentHub = TEAMS_HUB;
            }
            else if (hubNameLowerCase === "outlookwin32") {
                currentHub = WIN32_OUTLOOK_HUB;
            }
            else if (hubNameLowerCase === "outlook") {
                if (hostClientTypeLowerCase === "desktop") {
                    currentHub = MONARCH_HUB;
                }
                else if (hostClientTypeLowerCase === "web") {
                    currentHub = OWA_HUB;
                }
                else if (hostClientTypeLowerCase === "ios") {
                    currentHub = IOS_OUTLOOK;
                }
                else if (hostClientTypeLowerCase === "android") {
                    currentHub = ANDROID_OUTLOOK;
                }
                else {
                    currentHub = OUTLOOK_OTHER_HUB;
                }
            }
            else if (hubNameLowerCase === "office") {
                if (hostClientTypeLowerCase === "desktop") {
                    currentHub = OFFICE_DESKTOP;
                }
                else if (hostClientTypeLowerCase === "web") {
                    currentHub = OFFICE_WEB;
                }
                else if (hostClientTypeLowerCase === "ios") {
                    currentHub = OFFICE_IOS;
                }
                else if (hostClientTypeLowerCase === "android") {
                    currentHub = OFFICE_ANDROID;
                }
                else {
                    currentHub = OFFICE_OTHER_HUB;
                }
            }
            else if (hubNameLowerCase === "windowsactioncenter") {
                currentHub = WINDOWSACTIONCENTER;
            }
            else {
                currentHub = HUB;
            }
        }
        else {
            // log hubName
            currentHub = HUB;
        }
    }
}

export function getHostHub(): string | undefined {
    return currentHub;
}
